import { gql } from '@apollo/client'

import { METADATA_NODE_FRAGMENT } from '../../../common/graphql/fragments'

const UPDATE_DISH_TYPE_BY_MENU_TITLE_MUTATION = gql`
  mutation updateDishTypeByMenuTitleMutation(
    $dishTypeId: ID
    $menuTitleId: ID!
  ) {
    updateDishTypeByMenuTitle(
      dishTypeId: $dishTypeId
      menuTitleId: $menuTitleId
    ) {
      id
      dishType {
        ...MetadataNodeFragment
      }
      courseType {
        ...MetadataNodeFragment
      }
      isManualIgnored
      isAiIgnored
    }
  }
  ${METADATA_NODE_FRAGMENT}
`

export default UPDATE_DISH_TYPE_BY_MENU_TITLE_MUTATION
